<template>
  <div class="products-page trash-page content-list-page" dir="rtl">
    <div class="products-hero">
      <div>
        <p class="hero-kicker mb-1">{{ labels.plural }}</p>
        <h1 class="mb-0">سطل زباله</h1>
      </div>
      <div class="hero-side">
        <div class="hero-count" v-if="paginationMeta && paginationMeta.total != null">
          <strong>{{ formatNumber(paginationMeta.total) }}</strong>
          <span>{{ labels.single }} حذف‌شده</span>
        </div>
        <div class="hero-badge"><b-icon icon="trash"></b-icon></div>
      </div>
    </div>

    <div class="products-toolbar">
      <div class="products-toolbar-actions">
        <router-link v-if="labels.back" class="products-tool-btn trash-back-btn" :to="{ name: labels.back }">
          <span>بازگشت به {{ labels.plural }}</span>
          <b-icon icon="arrow-left"></b-icon>
        </router-link>
      </div>
      <div class="products-filter-bar">
        <div class="trash-filter-row">
          <label class="products-filter-field trash-search-field">
            <span><b-icon icon="search"></b-icon> جستجو در این صفحه</span>
            <input class="products-filter-input" v-model="searchInput" placeholder="عنوان..."
                   @keydown.enter.prevent>
          </label>
          <button v-if="searchInput" type="button" class="products-more-btn" @click="searchInput = ''">
            <b-icon icon="x-lg"></b-icon>
            <span>پاک کردن</span>
          </button>
        </div>
      </div>
    </div>

    <div class="products-list-panel">
      <tabel-items :items="filteredItems" :loading="loading" :restoreState="true" :content-type="contentTypes[contentType]"/>
      <div class="products-pager" v-if="!loading && paginationMeta && paginationMeta.last_page > 1">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </div>
    </div>
  </div>
</template>

<script>
import tabelItems from "./tableItems.vue";
import {mapGetters} from "vuex";
import Pagination from "../Pagination";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import "../product/products-ui.css";
import "../trash-ui.css";

const LABELS = {
  posts: {plural: 'پست‌ها', single: 'پست', back: 'PostsDashboard'},
  pages: {plural: 'برگه‌ها', single: 'برگه', back: 'PagesDashboard'},
  lesson: {plural: 'درس‌ها', single: 'درس', back: 'LessonsDashboard'},
}

export default {
  name: "trashItems",
  components: {tabelItems, Pagination},
  data() {
    return {
      loading: true,
      searchInput: '',
      contentTypes: {
        posts: 'post',
        pages: 'page',
        lesson: 'lesson',
      }
    };
  },
  computed: {
    ...mapGetters({
      'TrashContents': "Content/getTrashContents",
      paginationMeta: "Content/getPaginationMeta",
    }),
    contentType() {
      return this.$route.params.type
    },
    labels() {
      return LABELS[this.contentType] || {plural: 'محتوا', single: 'مورد', back: null}
    },
    filteredItems() {
      const list = Array.isArray(this.TrashContents) ? this.TrashContents : []
      const q = String(this.searchInput || '').trim().toLowerCase()
      if (!q) return list
      return list.filter(item => String(item.title || '').toLowerCase().indexOf(q) > -1)
    },
  },
  watch: {
    contentType() {
      this.fetch(1)
    },
  },
  methods: {
    formatNumber,
    async fetch(page) {
      this.loading = true
      try {
        await this.$store.dispatch("Content/getTrashContents", {content_type: this.contentTypes[this.contentType], page: page});
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    changePage(page) {
      this.fetch(page)
    },
  },
  mounted() {
    this.$store.commit("Content/setTrash", []);
    this.fetch(1)
  }
};
</script>
